function SwitchAccount2() {
  return (
    <svg
      width={39}
      height={40}
      viewBox="0 0 39 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="switch-account-2-icon"
    >
      <path
        d="M1.548 18.224A1.548 1.548 0 010 16.676c0-5.32 4.328-9.648 9.649-9.648h26.558a1.548 1.548 0 110 3.095H9.649a6.56 6.56 0 00-6.553 6.553c0 .856-.694 1.548-1.548 1.548z"
        fill="#f32645"
      />
      <path
        d="M37.236 10.124c-.415 0-.829-.166-1.134-.494l-6.536-7.028A1.547 1.547 0 1131.833.494l6.536 7.028a1.55 1.55 0 01-1.133 2.602z"
        fill="#f32645"
      />
      <path
        d="M30.7 17.151a1.549 1.549 0 01-1.133-2.601l6.536-7.028A1.549 1.549 0 0138.37 9.63l-6.535 7.028a1.55 1.55 0 01-1.134.493zM29.14 32.97H2.584a1.548 1.548 0 110-3.096H29.14a6.562 6.562 0 006.554-6.554 1.548 1.548 0 113.095 0c0 5.322-4.328 9.65-9.648 9.65z"
        fill="#f32645"
      />
      <path
        d="M8.082 40c-.414 0-.828-.167-1.134-.495L.414 32.478A1.548 1.548 0 112.68 30.37l6.534 7.027A1.55 1.55 0 018.082 40z"
        fill="#f32645"
      />
      <path
        d="M1.548 32.97a1.548 1.548 0 01-1.133-2.601l6.534-7.028a1.548 1.548 0 112.267 2.108l-6.534 7.027c-.306.329-.72.494-1.134.494z"
        fill="#f32645"
      />
    </svg>
  );
}

export default SwitchAccount2;
